import { useMemo, useCallback } from "react";
import { OutrasPartes, OutrasPartesTitulo } from "./styles";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import toast from "react-hot-toast";
import { toastDefsError } from "../../../../../../config/toastConfig";
import { BlocoOutrasPartesProps } from "./types";
import { usePartes } from "./hooks/usePartes";
import FormularioParte from "./FormularioParte";
import FormularioRepresentada from "./FormularioRepresentada";
import PartesProcessoList from "./PartesProcessoList";
import PartesRepresentadasList from "./PartesRepresentadasList";
import ModalExcluir from "./ModalExcluir";

export default function BlocoOutrasPartes({
    partesProcesso = [],
    partesRepresentadas = [],
    loading = false,
    isEditing = false,
    isDisabled = false,
    onChange,
    onPartesChange,
    onPartesRepresentadasChange
}: BlocoOutrasPartesProps) {
    const {
        partesEditando,
        partesRepresentadasEditando,
        formularioParte,
        formularioRepresentada,
        modalExcluir,
        mapaProcesso,
        podeAdicionarParte,
        podeAdicionarRepresentada,
        setFormularioParte,
        setFormularioRepresentada,
        handleAdicionarParte,
        handleAdicionarRepresentada,
        handleExcluirParte,
        confirmarExclusao,
        alternarRepresentada,
        fecharModal
    } = usePartes({
        partesProcesso,
        partesRepresentadas,
        isEditing,
        onPartesChange,
        onPartesRepresentadasChange,
        onChange
    });

    const handleAdicionarParteComValidacao = useCallback(() => {
        if (!podeAdicionarParte) {
            toast.error('Qualificação e Nome são obrigatórios', toastDefsError);
            return;
        }
        handleAdicionarParte();
    }, [podeAdicionarParte, handleAdicionarParte]);

    const handleAdicionarRepresentadaComValidacao = useCallback(() => {
        if (!podeAdicionarRepresentada) {
            toast.error('Nome é obrigatório', toastDefsError);
            return;
        }
        handleAdicionarRepresentada();
    }, [podeAdicionarRepresentada, handleAdicionarRepresentada]);

    const partesExibidas = useMemo(
        () => isEditing ? partesEditando : partesProcesso,
        [isEditing, partesEditando, partesProcesso]
    );

    const representadasExibidas = useMemo(
        () => isEditing ? partesRepresentadasEditando : partesRepresentadas,
        [isEditing, partesRepresentadasEditando, partesRepresentadas]
    );

    if (loading) {
        return (
            <OutrasPartes>
                <div>
                    <Skeleton height={80} width="100%" style={{ marginBottom: '8px' }} />
                    <Skeleton height={80} width="100%" />
                </div>
                <div>
                    <Skeleton height={80} width="100%" style={{ marginBottom: '8px' }} />
                    <Skeleton height={80} width="100%" />
                </div>
            </OutrasPartes>
        );
    }

    return (
        <div>
            <OutrasPartesTitulo>Outras Partes</OutrasPartesTitulo>
            <OutrasPartes>
                <div>
                    <span className="label">Partes do Processo</span>
                    {isEditing && (
                        <FormularioParte
                            formulario={formularioParte}
                            podeAdicionar={podeAdicionarParte}
                            isDisabled={isDisabled}
                            onChange={setFormularioParte}
                            onAdicionar={handleAdicionarParteComValidacao}
                        />
                    )}
                    <PartesProcessoList
                        partes={partesExibidas}
                        isEditing={isEditing}
                        isDisabled={isDisabled}
                        onAlternarRepresentada={alternarRepresentada}
                        onExcluir={handleExcluirParte.bind(null, 'processo')}
                    />
                </div>
                <div>
                    <span className="label">Partes Representadas</span>
                    {isEditing && (
                        <FormularioRepresentada
                            formulario={formularioRepresentada}
                            podeAdicionar={podeAdicionarRepresentada}
                            isDisabled={isDisabled}
                            onChange={setFormularioRepresentada}
                            onAdicionar={handleAdicionarRepresentadaComValidacao}
                        />
                    )}
                    <PartesRepresentadasList
                        partes={representadasExibidas}
                        mapaProcesso={mapaProcesso}
                        isEditing={isEditing}
                        isDisabled={isDisabled}
                        onExcluir={handleExcluirParte.bind(null, 'representada')}
                    />
                </div>
            </OutrasPartes>
            <ModalExcluir
                modal={modalExcluir}
                onConfirmar={confirmarExclusao}
                onCancelar={fecharModal}
            />
        </div>
    );
}
